import React, { FC, ReactNode } from "react";
import { useGuardianContext } from "../../../context/GuardianContext";

export interface GuardianLayoutProps {
    children: ReactNode,
    formTitle?: string,
    isCurrentGuardianSinged: boolean,
    submit: () => Promise<void>,
    isOtherGuardiansSigned: boolean,
    currentGuardianIsActive: boolean
}

export const GuardianLayout: FC<GuardianLayoutProps> = ({children, formTitle, submit, isCurrentGuardianSinged, isOtherGuardiansSigned, currentGuardianIsActive}) => {

    const { loading } = useGuardianContext();

    return (
        <div className="h-100">
            <div className="main-container container-fluid">
                <div className="vertical-nav">
                    <img className="main-logo" src={require('../../../images/main-logo.svg')} alt="" />
                </div>
                <div className="main-content">
                    <div className="nav-header-container">
                        <div className="subheader-text">
                            <span>{formTitle}</span>
                        </div>
                        { currentGuardianIsActive && !isCurrentGuardianSinged && !isOtherGuardiansSigned && 
                            <button className="subheader-add-btn" disabled={loading} onClick={submit}>Submit</button>
                        }
                    </div> 
                    {children}
                </div>
            </div>
        </div>
    )
}